import { render, staticRenderFns } from "./sharedResourceGoodsMaintenance.vue?vue&type=template&id=6e98c55a&scoped=true"
import script from "./sharedResourceGoodsMaintenance.vue?vue&type=script&lang=js"
export * from "./sharedResourceGoodsMaintenance.vue?vue&type=script&lang=js"
import style0 from "./sharedResourceGoodsMaintenance.vue?vue&type=style&index=0&id=6e98c55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e98c55a",
  null
  
)

export default component.exports